import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ProfilesModule } from '@app/features/profiles';

import { PanelListComponent } from './panel-list/panel-list.component';
import { PanelDialogComponent } from './panel-dialog/panel-dialog.component';
import { PanelManagerComponent } from './panel-manager/panel-manager.component';
import { MyPanelsComponent } from './my-panels/my-panels.component';
import { PanelDetailComponent } from './panel-detail/panel-detail.component';
import { LazyLoadDirective } from './directives/lazy-load.directive';
import { IframeViewerComponent } from './iframe/iframe-viewer.component';
import { CommentDialogComponent } from './components/comment-dialog/comment-dialog.component';
import { CommentListComponent } from './components/comment-list/comment-list.component';

@NgModule({
  declarations: [
    PanelListComponent,
    PanelDialogComponent,
    PanelManagerComponent,
    MyPanelsComponent,
    PanelDetailComponent,
    LazyLoadDirective,
    IframeViewerComponent,
    CommentDialogComponent,
    CommentListComponent,
  ],
  imports: [SharedModule, ProfilesModule],
})
export class PanelsModule {}
